let socket = null;

export const connectChatSocket = (sessionId, onStep) => {
  console.log("session id hjkjhkjhkjhk", sessionId);
  if (!sessionId) {
    console.warn("WS: sessionId missing");
    return;
  }

  if (socket && socket.readyState === WebSocket.OPEN) {
    console.log("WS: already connected");
    return;
  }
  console.log("session id hjkjhkjhkjhk", sessionId);
  socket = new WebSocket(
    `wss://llmbackend.infitouch.in/ws/query?session_id=${sessionId}`
  );

  socket.onopen = () => {
    console.log("WS: connected");
  };

  socket.onmessage = (event) => {
    console.log("WS RAW:", event.data);

    let data = event.data;

    try {
      data = JSON.parse(event.data);
    } catch (e) {}

    console.log("WS FINAL DATA:", data);

    if (window.addBotStep) {
      window.addBotStep(data);
    }
  };
  socket.onerror = (err) => {
    console.error("WS ERROR:", err);
  };

  socket.onclose = () => {
    console.log("WS: closed");
    socket = null;
  };
};

export const closeChatSocket = () => {
  if (socket) {
    socket.close();
    socket = null;
  }
};
